import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "account-payment" */ './index'),
  loading: () => null,
})
